import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useAppCurrentUserMetaQuery, useToggleAppLikeMutation } from '@shared/hooks/query';

// TODO: we probably need to update the logic to get rid of useState and
// use only cache of the query and update it using queryClient.setQueryDAta
export const useAppLike = ({ appId, appLink }: { appId: number; appLink: string }) => {
  const { isAuth } = useAuth();
  const { data, isPending: isLoading } = useAppCurrentUserMetaQuery(appLink, {
    enabled: isAuth,
  });
  const lastUpdatedValue = !!data?.attributes?.liked;
  const initialValue = useRef(lastUpdatedValue).current;
  const [value, setValue] = useState(lastUpdatedValue);
  const { mutate } = useToggleAppLikeMutation();

  const toggle = () => {
    setValue((oldLike) => !oldLike);
  };

  useLayoutEffect(() => {
    setValue(lastUpdatedValue);
  }, [lastUpdatedValue]);

  useEffect(() => {
    if (isLoading || value === lastUpdatedValue) {
      return;
    }

    const timeoutId = setTimeout(() => {
      mutate({
        appId,
        appLink,
        like: value,
      });
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, mutate, lastUpdatedValue, appId]);

  return {
    value,
    initialValue,
    toggle,
  };
};
